import { geldigLeerlingnummer, LEERLINGNUMMER_MAX } from '../lib/leerlingnummer';
import { useEffect, useRef, useState } from 'react';

/** Maximale stilte tussen twee tekens van dezelfde scan. */
export const SCANNER_STILTE_MS = 300;
export const SCANNER_MAX_LENGTE = LEERLINGNUMMER_MAX;

/** Eén globale invoerroute, onafhankelijk van de toetsenbordfocus. */
export function useScanner(onScan: (nummer: string) => void, stilteMs = SCANNER_STILTE_MS, actief = true) {
  const [buffer, setBuffer] = useState('');
  const laatsteGenegeerdeToets = useRef<number | null>(null);
  const callback = useRef(onScan);
  callback.current = onScan;

  useEffect(() => {
    setBuffer('');
    let invoer = '';
    let teLang = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const wis = () => {
      clearTimeout(timer);
      invoer = '';
      teLang = false;
      setBuffer('');
    };
    const toets = (event: KeyboardEvent) => {
      if (event.ctrlKey || event.altKey || event.metaKey) return;
      // Een scan die tijdens expliciete uitschakeling begon volledig weggooien.
      const vorige = laatsteGenegeerdeToets.current;
      if (!actief || (vorige !== null && Date.now() - vorige < stilteMs)) {
        if (event.key === 'Enter' || event.key.length === 1) {
          event.preventDefault();
          laatsteGenegeerdeToets.current = event.key === 'Enter' ? null : Date.now();
        }
        wis();
        return;
      }
      laatsteGenegeerdeToets.current = null;
      if (event.key === 'Enter') {
        event.preventDefault();
        // Nooit naar een getal omzetten: voorloopnullen horen bij de pascode.
        const nummer = invoer;
        const geldig = !teLang && geldigLeerlingnummer(nummer);
        wis();
        if (geldig) callback.current(nummer);
      } else if (/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        if (invoer.length < SCANNER_MAX_LENGTE) invoer += event.key;
        else teLang = true; // Een te lange scan niet als een ander nummer versturen.
        setBuffer(invoer);
        clearTimeout(timer);
        timer = setTimeout(wis, stilteMs);
      } else if (event.key.length === 1) {
        teLang = true; // Ongeldige tekens mogen geen ander, geldig nummer opleveren.
      }
    };
    window.addEventListener('keydown', toets, true);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('keydown', toets, true);
    };
  }, [stilteMs, actief]);
  return buffer;
}
